import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';

interface ActiveDaysProps {
    onChange: (newValue: number[]) => void;
    value: number[];
}

const defaultList: number[] = [1, 2, 3, 4, 5, 6, 7];

export default function ActiveDays({ onChange, value = defaultList }: Readonly<ActiveDaysProps>) {
    const handleChange = (day: number) => {
        const currentIndex = value.indexOf(day);
        const newValue = [...value];
        if (currentIndex === -1) {
            newValue.push(day);
        } else {
            newValue.splice(currentIndex, 1);
        }
        onChange(newValue);
    };

    const days = [
        { label: 'Mon', value: 1 },
        { label: 'Tue', value: 2 },
        { label: 'Wed', value: 3 },
        { label: 'Thu', value: 4 },
        { label: 'Fri', value: 5 },
        { label: 'Sat', value: 6 },
        { label: 'Sun', value: 7 },
    ];

    return (
        <FormGroup row>
            {days.map((day) => (
                <FormControlLabel
                    control={<Checkbox checked={value.includes(day.value)} onChange={() => handleChange(day.value)} />}
                    key={day.value}
                    label={day.label}
                    labelPlacement="top"
                    sx={{ mx: 1, textAlign: 'center' }}
                />
            ))}
        </FormGroup>
    );
}
